import {CONFIG} from "~/config";

export const collectionNameV1 = (name: string) =>
  `${CONFIG.COLLECTION_V1}-${name}`;

export const collectionNameV2 = (name: string) =>
  `${CONFIG.COLLECTION_V2}-${name}`;
